/* eslint-disable react/prop-types */
import { Card, CardBody, CardHeader } from "reactstrap";
import dayjs from "dayjs";

export default function ShiftSection({ shiftIndex, pattern, children }) {
  const roleTitle = pattern?.role?.title ?? "Shift";
  const start = pattern?.startTime;
  const end = pattern?.endTime;

  return (
    <Card className="mb-3">
      <CardHeader className="bg-light">
        <h5 className="mb-1">
          Shift {shiftIndex + 1} — {roleTitle}
        </h5>
        <div className="text-muted small">
          {start && end ? (
            <>
              {dayjs(`2000-01-01T${start}`).format("h:mm A")} –{" "}
              {dayjs(`2000-01-01T${end}`).format("h:mm A")}
            </>
          ) : (
            "—"
          )}
          {pattern?.quantity != null && (
            <span className="ms-2">· {pattern.quantity} worker(s)</span>
          )}
        </div>
        {pattern?.hasPPEProvided && pattern?.ppeInstruction ? (
          <div className="small mt-1 text-muted">
            <i className="mdi mdi-shield-outline me-1" />
            PPE: {pattern.ppeInstruction}
          </div>
        ) : null}
      </CardHeader>
      <CardBody
        className="p-2"
        style={{
          backgroundColor: "#f8f9fa",
          maxHeight: "1000px",
          overflowY: "auto",
          border: "1px solid #e9ecef",
        }}
      >
        {children}
      </CardBody>
    </Card>
  );
}
